<template>
  <vxe-modal v-model="visible" :loading="loading" :title="$t('menu.systemParameterSetting')" type="confirm" width="50%" @confirm="confirm">
    <a-form-model ref="form" :colon="false" :label-col="{span:8}" :model="data" :rules="rules" :wrapper-col="{span:16}">
      <a-row style="margin-left: -4%;margin-right: 4%">
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.parameterName')" prop="name">
            <vxe-input v-model="data.name" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.customized')" prop="customized">
            <vxe-switch v-model="data.customized"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.parameterValue')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" prop="value">
            <SmartForm v-model="data.value" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.enterprise')" prop="enterprise">
            <vxe-select v-model="data.enterprise.id" :options="enterprises" style="width: 100%" @change="onEnterpriseChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="12">
          <a-form-model-item :label="$t('business.label.warehouse')" prop="warehouse">
            <vxe-select v-model="data.warehouse.id" :options="warehouses" style="width: 100%" @change="onWarehouseChange"/>
          </a-form-model-item>
        </a-col>
        <a-col span="24">
          <a-form-model-item :label="$t('business.label.parameterNote')" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" prop="notes">
            <vxe-textarea v-model="data.notes" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </vxe-modal>
</template>

<script>
import { findAll, findOne, save } from '@/api/Api'
import { Parameter } from '@/api/dto/admin/Parameter'
import { Enterprise } from '@/api/dto/common/Enterprise'
import { Warehouse } from '@/api/dto/common/Warehouse'
import SmartForm from '@/components/SmartForm/SmartForm.vue'
import { getOptions } from '@/utils/util'

export default {
  name: 'ParameterEditor',
  components: { SmartForm },
  data() {
    return {
      visible: false,
      loading: false,
      data: new Parameter(),
      enterprises: [],
      warehouses: [],
      rules: {
        name: [{ required: true, message: this.$t('message.canNotBeEmpty') }],
        value: [{ required: true, message: this.$t('message.canNotBeEmpty') }]
      }
    }
  },
  created() {
    // 尝试解析value为JSON对象
    if (this.data.value && typeof this.data.value === 'string') {
      try {
        this.data.value = JSON.parse(this.data.value)
      } catch (e) {
        // 保持原样
      }
    }
    findAll('enterpriseFactory', { available: true }).then(res => {
      if (res.success) {
        this.enterprises = getOptions(res.result)
      }
      return findAll('warehouseFactory', { all: true })
    }).then(res => {
      if (res.success) {
        this.warehouses = getOptions(res.result)
      }
    })
  },
  methods: {
    onEnterpriseChange(value) {
      this.data.enterprise = new Enterprise({ id: value })
    },
    onWarehouseChange(value) {
      if (!value) this.onEnterpriseChange()
      this.data.warehouse = new Warehouse({ id: value })
    },
    add() {
      this.visible = true
      this.data = new Parameter()
      this.data.available = true
    },
    edit(id, copy) {
      this.visible = true
      this.loading = true
      findOne('parameterFactory', { id: id }).then(res => {
        if (res.success) {
          if (copy) {
            res.result.id = undefined
            res.result.version = undefined
          }
          this.data = new Parameter(res.result)
        }
      }).finally(() => this.loading = false)
    },
    save() {
      this.loading = true
      const data = this.data.toJSONObject()
      save('parameterPersister', data).then(res => {
        if (res.success) {
          this.data = new Parameter(res.result)
          this.$message.success(this.$t('message.saveSuccess'))
          this.$emit('success')
          this.visible = false
        }
      }).finally(() => this.loading = false)
    },
    confirm() {
      this.$refs.form.validate((success) => {
        if (success) {
          // 确保value是字符串格式
          if (typeof this.data.value !== 'string') {
            try {
              this.data.value = JSON.stringify(this.data.value)
            } catch (e) {
              this.data.value = ''
            }
          }
          this.save()
        }
      })
    }
  }
}
</script>